module.exports = __webpack_public_path__ + "img/dinkenclave-1.cc4557ac.jpeg";